import "./index.less";
import template from "./index.html";

/*
type PaginatorOptions {
	currentPage: number;
	itemsPerPage: number;
	totalItems: number;
}
*/

function controller($scope, $state, $logger, $location) {
	const ctrl = this;
	ctrl.scope = $scope;

	ctrl.$onInit = () => {
		ctrl.pageSizes = ctrl.pageSizes || ["10", "25", "50", "75"];
		ctrl.minimumTotalItems = ctrl.minimumTotalItems ?? 10;
		ctrl.label = ctrl.label || "Items per page";
		ctrl.showLabel = ctrl.showLabel ?? true;

		ctrl.options = ctrl.options || {};
		ctrl.options.currentPage = ctrl.options?.currentPage || 1;
		ctrl.options.itemsPerPage =
			ctrl.options?.itemsPerPage
			?? (ctrl.pageSizes.indexOf(ctrl.defaultPageSize) > -1 ? ctrl.defaultPageSize : null)
			?? ctrl.pageSizes[0];
		ctrl.options.totalItems = ctrl.options?.totalItems || 0;

		$scope.$watch(() => ctrl.options.totalItems, resetPage, true);
		$scope.$watch(() => ctrl.options.currentPage, (next, prev) => filterNonChange(next, prev, false), true);
		$scope.$watch(
			() => ctrl.options.itemsPerPage,
			(next, prev) => {
				filterNonChange(next, prev, false);
				ctrl.updateUserPreference && ctrl.updateUserPreference(ctrl.options.itemsPerPage);
			}, true);
		$scope.$watch(() => ctrl.options.totalItems, (next, prev) => filterNonChange(next, prev, true), true);
	};

	function resetPage(nextTotalItems, prevTotalItems) {
		if(nextTotalItems !== undefined
			&& nextTotalItems != prevTotalItems
			&& (nextTotalItems === 0 || nextTotalItems < getCurrentOffset())) {
			ctrl.options.currentPage = 1;
			ctrl.options.totalItems = nextTotalItems ?? 0;
		}
	}

	function getCurrentOffset() {
		return (ctrl.options.itemsPerPage * (ctrl.options.currentPage - 1));
	}

	function getCurrentMaxPage() {
		return parseInt((ctrl.options.totalItems + parseInt(ctrl.options.itemsPerPage) - 1) / parseInt(ctrl.options.itemsPerPage));
	}

	function filterNonChange(next, prev, suppressCallback = false) {
		if(next !== prev) {
			const offset = getCurrentOffset();
			if(ctrl.options.totalItems < offset) {
				const maxPage = getCurrentMaxPage();
				ctrl.options.currentPage = maxPage;
			}
			else {
				updateRoute();
			}

			!suppressCallback && ctrl.updatePage && ctrl.updatePage();
		}
	}

	function stateSupportsParams(names) {
		// UI-Router 1.x: $state.$current.parameters() returns a param definition map
		if($state.$current && typeof $state.$current.parameters === "function") {
			const defs = $state.$current.parameters();
			return names.every((n) => defs.find((p) => p.id === n) !== undefined);
		}

		// Fallback: check the registered state declaration
		const decl = $state.get && $state.get($state.current && $state.current.name);
		const params = decl && decl.params;
		return !!params && names.every((n) => Object.prototype.hasOwnProperty.call(params, n));
	}

	function updateRoute() {
		const stateSupportsPaginatorParams = stateSupportsParams(["page", "itemsPerPage"]);
		if(stateSupportsPaginatorParams === false || ctrl.suppressRouteUpdates) {
			return;
		}
		
		window.scroll({ top: 0 });

		$location.search("page", ctrl.options.currentPage)
			.search("itemsPerPage", ctrl.options.itemsPerPage)
			.replace();
	}
}

export default angular
	.module("vesl.components.pagination", [])
	.component("pagination", {
		template,
		controller,
		bindings: {
			options: "=",
			pageSizes: "<",
			defaultPageSize: "<",
			minimumTotalItems: "<",
			label: "@",
			showLabel: "<",
			updateUserPreference: "=",
			updatePage: "=",
			suppressRouteUpdates: "<",
			id: "@"
		}
	}).name;
